###
Helpers for interacting with cart APIs
###
import fetchQuery from 'library/queries/shopify/cart/fetch.gql'
import createQuery from 'library/queries/shopify/cart/create.gql'
import addQuery from 'library/queries/shopify/cart/add.gql'
import updateQuery from 'library/queries/shopify/cart/update.gql'
import deleteQuery from 'library/queries/shopify/cart/delete.gql'
import discountsQuery from 'library/queries/shopify/cart/discounts.gql'
import linkCustomerQuery from 'library/queries/shopify/cart/link-customer.gql'
import { execute, findEdgeNodes } from './storefront'

# Throw errors if found in the response, else map the checkout object
handleCheckoutMutation = ({ mutation: response }) ->
	if response.userErrors?.length
	then throw JSON.stringify response.userErrors
	return response.cart

# Lookup a checkout
export fetch = (id) ->
	{ cart } = await execute
		query: fetchQuery
		variables: { id }
	return cart

# Create a new checkout
export create = ->
	handleCheckoutMutation await execute
		query: createQuery
		variables: input: {}

# Add an item to the checkout
export addVariant = ({
	cartId, variantId, quantity, sellingPlanId, attributes = {}
}) ->
	handleCheckoutMutation await execute
		query: addQuery
		variables:
			cartId: cartId
			lines: [
				merchandiseId: variantId
				quantity: quantity
				sellingPlanId: sellingPlanId
				attributes: { key, value } for key, value of attributes
			]

# Add multiple items to the checkout with the same attributes
export addVariants = ({ cartId, variantIds, quantity, attributes = {} }) ->
	handleCheckoutMutation await execute
		query: addQuery
		variables:
			cartId: cartId
			lines: variantIds.map (variantId) ->
				merchandiseId: variantId
				quantity: quantity
				attributes: { key, value } for key, value of attributes

# Update a line item
export updateLines = ({
	cartId, lineIds, quantity, sellingPlanId, attributes = {}
}) ->
	handleCheckoutMutation await execute
		query: updateQuery
		variables:
			cartId: cartId
			lines: lineIds.map (lineId) ->
				id: lineId
				quantity: quantity
				sellingPlanId: sellingPlanId
				attributes: { key, value } for key, value of attributes

# Update a line item
export deleteLines = ({ cartId, lineIds }) ->
	handleCheckoutMutation await execute
		query: deleteQuery
		variables:
			cartId: cartId
			lines: lineIds

# Update discount codes
export updateDiscounts = ({ cartId, codes }) ->
	handleCheckoutMutation await execute
		query: discountsQuery
		variables:
			cartId: cartId
			discountCodes: codes

# Associate a customer with the cart
export linkCustomer = ({ cartId, accessToken }) ->
	handleCheckoutMutation await execute
		query: linkCustomerQuery
		variables:
			cartId: cartId
			buyerIdentity: customerAccessToken: accessToken
